import { useEffect } from "react"


const useTitle= title=>{
    useEffect(()=>{
          document.title= `${title} -Moms Kitchen`
    },[title])
}



export default useTitle;